/**
 * FIX: Kein Redirect zur Cart-Page nach "In den Warenkorb"
 * Stattdessen öffnet sich der Cart Drawer.
 */
(function () {

  // Methode 1: Focal's eigenes Event abfangen
  document.addEventListener('variant:added', function () {
    var miniCart = document.getElementById('mini-cart');
    if (miniCart) {
      miniCart.open = true;
    }
  });

  // Methode 2: Sicherheitsnetz gegen native Form-Redirects
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form) return;
    if (form.getAttribute('is') !== 'product-form') return;

    var parentProductForm = form.closest('product-form');
    if (parentProductForm) return;

    event.preventDefault();

    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form)
    })
    .then(function (res) { return res.json(); })
    .then(function () {
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', { bubbles: true })
      );
      var miniCart = document.getElementById('mini-cart');
      if (miniCart) { miniCart.open = true; }
    })
    .catch(function (err) { console.error('[ATC Fix] Fehler:', err); });

  }, true);

})();